import StorageEngine from "./StorageEngine";

export const profileStorage = new StorageEngine("profile");
export const coursesStorage = new StorageEngine("course");
